module.exports = __webpack_public_path__ + "ae615b2a3aa6da29f10a08d420745edf.svg";